module.exports = __webpack_public_path__ + "37384e96c1331bd1c178c848d49477fd.png";